import { ModuleRendering, SlotRendering } from '@frontend/common-types';
import { SensorLockerStatus } from '@frontend/device/types';
import { SlotOpen } from '@frontend/icons';
import { SlotStatus, SlotType } from '@frontend/slot/types';
import { SpotRenderingClient } from '@frontend/spot/api';
import { FormattedMessage } from 'react-intl';

import { SpotLayout } from '../../../spot-rendering';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useProcessOpenCloseSpotLayout } from './process-open-close-spot-layout.controller';

const ID = 'process-open-close-spot-layout';

export const ProcessOpenCloseSpotLayout = () => {
    const viewProps = useProcessOpenCloseSpotLayout();

    if (!viewProps.store || !viewProps.transaction) return;
    return (
        <WizardScreenContainer id={ID}>
            <SpotLayout<ModuleRendering, SlotRendering>
                fetchSpotData={(arg) => SpotRenderingClient.fetchSpotRendering(viewProps.store!.wizard.account_id, viewProps.transaction!.spot_id!, arg)}
                fetchModuleData={(accountId, spotId, moduleId) => SpotRenderingClient.fetchSpotModuleRendering(accountId, spotId, moduleId)}
                enableZoom
                enableSlotHover={false}
                centered
                disableModuleExpand
                minScale={0.5}
                maxScale={1.2}
                styles={{
                    getSlotColor: (slot) => {
                        const status = viewProps.slotStatusMap.get(slot.id);
                        if (status === SensorLockerStatus.OPENED) {
                            return 'bg-status-success';
                        } else if (status === SensorLockerStatus.CLOSED) {
                            return 'bg-brand-secondary';
                        }
                        if (slot.type === SlotType.TERMINAL) {
                            return 'bg-brand-disabled';
                        }
                        if (slot.status === SlotStatus.NON_FUNCTIONAL) {
                            return 'bg-brand-disabled';
                        }

                        if (slot.occupied) {
                            return 'bg-brand-muted';
                        }

                        return 'bg-brand-secondary';
                    }
                }}
                slot={{
                    renderElement: (slot) => {
                        if (slot.type === SlotType.TERMINAL)
                            return (
                                <div className='text-background-surface pointer-events-none absolute bottom-0 left-0 pb-1 pl-2 text-xs font-semibold select-none'>
                                    <FormattedMessage
                                        id='slots-grid.slot-type.terminal'
                                        defaultMessage='Terminal'
                                    />
                                </div>
                            );
                        const status = viewProps.slotStatusMap.get(slot.id);
                        return (
                            <>
                                {status === SensorLockerStatus.OPENED && (
                                    <div className='flex h-full w-full items-center justify-center'>
                                        <SlotOpen className='text-background-surface h-5 w-5 opacity-66' />
                                    </div>
                                )}
                                <div className='text-background-surface pointer-events-none absolute bottom-0 left-0 pb-1 pl-2 text-xs font-semibold select-none'>
                                    {slot.number}
                                </div>
                            </>
                        );
                    }
                }}
            />
        </WizardScreenContainer>
    );
};
